var _g, _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3_1020)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.9651 16.244C22.9731 16.355 22.9731 16.4661 22.9731 16.5771C22.9731 19.9639 20.3953 23.8661 15.684 23.8661C14.2326 23.8661 12.8842 23.4457 11.75 22.7161C11.9562 22.7399 12.1545 22.7478 12.3687 22.7478C13.5663 22.7478 14.6688 22.3433 15.5492 21.6533C14.4229 21.6295 13.4791 20.8919 13.1539 19.8766C13.3125 19.9004 13.4711 19.9163 13.6377 19.9163C13.8677 19.9163 14.0977 19.8845 14.3119 19.829C13.138 19.5911 12.2576 18.56 12.2576 17.3148V17.283C12.5986 17.4734 12.9952 17.5924 13.4156 17.6082C12.7255 17.1482 12.2735 16.363 12.2735 15.4746C12.2735 14.9988 12.4003 14.5625 12.6224 14.1818C13.8835 15.7364 15.7792 16.7516 17.9048 16.8627C17.8652 16.6723 17.8414 16.474 17.8414 16.2757C17.8414 14.8639 18.9835 13.7139 20.4032 13.7139C21.1409 13.7139 21.8071 14.0232 22.2751 14.5229C22.854 14.4118 23.4093 14.1977 23.901 13.9042C23.7106 14.4991 23.3061 14.9988 22.7748 15.316C23.2903 15.2605 23.79 15.1177 24.25 14.9195C23.9011 15.4271 23.4648 15.8791 22.9651 16.244Z",
    fill: "white"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1.79004,
    width: 34,
    height: 34,
    rx: 17,
    stroke: "white",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3_1020"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 11,
    fill: "white",
    transform: "translate(11.5 13.29)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.302415dfb6035c6b6186f855a3bfecb1.svg";
export { ForwardRef as ReactComponent };